<template>
  <div class="tab-main-markets">
    <SectionSearchSelect
        :title="'Lotteries'"
        :isSelectAll="false"
        @search="handleSearch"
        :classDownKeyboard="'.first-checkbox-market-additional'"
        :classDownSelectAll="'.first-checkbox-radio'"
    />
    <SectionTable
        :isSelectRadio="true"
        :listData="listGamesToShow"
        :listTitle="listTitleLotteriesAdditional"
        :classLastItem="'last-checkbox-market-additional'"
        :classFirstItem="'first-checkbox-market-additional'"
        :toClassFirstItem="'.first-checkbox-market-additional'"
        :toClassLastItem="'.last-checkbox-market-additional'"
        :classKeyboardLastCheckbox="'.input-group-append-additional'"
        @tabNextSection="handleNextSectionMarket"
        @changeRadioCheckbox="handleChangeRadioCheckboxLotteries"
    />
    <div class="retail__markets">
      <SectionSearchSelect
          :isFocusSearch="isFocusSearch"
          :isSelectAll="false"
          :title="'Markets'"
          @search="handleSearchMarkets"
          :classSearchInput="'input-group-append-additional'"
          :classDownKeyboard="'.under-over__item'"
          :classDownSelectAll="'.under-over__item'"
      />
      <div class="retail__markets__table">
        <div
            v-for="(value, index) in moreMarketsToShow"
            :key="index"
            class="additional-market"
        >
          <div class="additional-market__market__title">
            {{ value.name }}
          </div>
          <div class="ball-toggle"
               v-for="(item, i) in value.markets"
               :key="i">
            <div v-if="item.select_numbers === 'no'">
              <BallToggle
                  :title="item.description"
                  :data=dataUnderOver
                  :data-component="item"
                  @toggle="item.isActiveToggle = !item.isActiveToggle"
                  :isShow="item.isActiveToggle"
                  @clickItem="handleClickItem(i, $event)"
              />
            </div>
<!--            <div v-else-if="item.select_numbers === 'yes'">-->
<!--              <div v-for="(number, key) in numbersBonusBall" :key="key">-->
<!--                <BallToggle-->
<!--                    v-if="number.key === item.keyNumbers"-->
<!--                    :title="item.description"-->
<!--                    :numbers="number.numbers"-->
<!--                    :data=BallNumbers-->
<!--                    @handleChosenItem="handleChosenNumberBonusBall($event, item.outcomes)"-->
<!--                    @toggle="item.isActiveToggle = !item.isActiveToggle"-->
<!--                    :isShow="item.isActiveToggle"-->
<!--                />-->
<!--              </div>-->
<!--            </div>-->
          </div>
        </div>
      </div>
    </div>
    <div class="retail__bet">
        <div class="retail__bet__draws">
          <div class="retail__bet__draws__title retail__title-common">
            DRAWS
          </div>
          <div class="btn-group retail__bet__draws__contents">
            <button
                ref="dropdown"
                @keydown.down.prevent="nextSectionDropdown"
                type="button"
                class="btn btn-outline-primary dropdown-toggle focusable downDraw"
                data-sn-right=".inputPrice"
                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              {{ numberDrawDropdown }}
            </button>
            <ul class="dropdown-menu">
              <li
                  v-for="(item, index) in numberDropdown"
                  :key="index"
              >
                <div
                    :tabindex='index'
                    v-if="index === numberDropdown-1"
                    class="dropdown-item focusable"
                    id="idDropdownMarket"
                    :class="{active: numberDrawDropdown=== index+1}"
                    data-sn-down=".dropdown-toggle"
                    @keydown.space.stop="handleSelectDrawDropdown(item)"
                    @keydown.enter.stop="handleSelectDrawDropdown(item)"
                    @click="handleSelectDrawDropdown(item)"
                >
                  {{ item }}
                </div>
                <div
                    :tabindex='index'
                    v-if="index !== numberDropdown-1 && index !== 0"
                    class="dropdown-item focusable"
                    id="idDropdownMarket1"
                    :class="{active: numberDrawDropdown=== index+1}"
                    @keydown.space.stop="handleSelectDrawDropdown(item)"
                    @keydown.enter.stop="handleSelectDrawDropdown(item)"
                    @click="handleSelectDrawDropdown(item)"
                >
                  {{ item }}
                </div>
                <div
                    :tabindex='index'
                    v-if="index !== numberDropdown-1 && index === 0"
                    class="dropdown-item focusable"
                    data-sn-up=".dropdown-toggle"
                    id="idDropdownMarket2"
                    :class="{active: numberDrawDropdown=== index+1}"
                    @keydown.space.stop="handleSelectDrawDropdown(item)"
                    @keydown.enter.stop="handleSelectDrawDropdown(item)"
                    @click="handleSelectDrawDropdown(item)"
                >
                  {{ item }}
                </div>
              </li>
            </ul>
          </div>
        </div>
      <div class="retail__bet__bet-per-line">
        <div class="retail__bet__bet-per-line__title retail__title-common">
          BET PER LINE
        </div>
        <div class="retail__bet__bet-per-line__input">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text" id="basic-addon1">{{ currency }}</span>
            </div>
            <input
                v-model="betPerLine"
                ref="refBetPerLine"
                data-sn-right=".btn__add-to-betslip"
                data-sn-left=".downDraw"
                type="number"
                class="form-control focusable inputPrice"
                placeholder=""
                aria-label="Username"
                aria-describedby="basic-addon1"
            >
            <div
                v-if="betPerLine < betMin"
                class="input-group__error"
            >
              Bet min is {{betMin}}
            </div>
            <div
                v-if="betPerLine > betMax"
                class="input-group__error"
            >
              Bet max is {{betMax}}
            </div>
          </div>
        </div>
      </div>
      <div class="retail__bet__bet-total">
        <div class="retail__bet__bet-total__title retail__title-common">TOTAL</div>
        <div class="retail__bet__bet-total__value">
          {{ currency }} {{ betPerLine * numberDrawDropdown }}
        </div>
      </div>
      <div class="retail__bet__add-to-betslip">
        <button
            @click="handleAddToBetslip"
            :disabled="!isSelectMarket || betPerLine > betMax || betPerLine < betMin"
            type="button"
            data-sn-down=".button-betslip-common"
            data-sn-left=".inputPrice"
            data-sn-right=".inputPrice"
            class="btn btn-primary btn__add-to-betslip focusable"
        >
          ADD TO BETSLIP
        </button>
      </div>
    </div>
    <ModalCommon
        v-if="showModalBetslip"
        @close="showModalBetslip = false"
        @login="handleLogin"
        @process-bet="processBetslipTransat"
        @book-a-bet="handleBookABet"
        :isClassModalCustom="isModalCustomClass"
    >
      <YourBetslip
        @print="handlePrint"
        :isShowPrint="printBet"
        :data-betslip="listDataBetslipsRetail"
        v-bind:commonStake="commonStake"
        v-bind:totalStake="totalStake"
        :loading="loadingProcessBet"
        :loading-boot-a-bet="loadingBootABet"
        :is-disable-process-bet="isDisableProcessBet"
        :is-show-error-expired="isShowErrorExpired"
        :is-show-res-book-a-bet="isShowResBookABet"
        :booking-code-boot-a-bet="bookingCodeBootABet"
        @changeStake="handleChangeStake"
        @removeItemBetslip="handleRemoveItemBetslip"
        @removeAllBetslip="handleRemoveAllBetslips"
        @removeDrawsExpired="removeDrawsExpired"
        @moveToNextDraw="moveToNextDraw"
        @addClassModalClass="handleToggleClassModal"
      />
    </ModalCommon>
  </div>

</template>

<script>
import SectionSearchSelect from '@/components/common/retail-common/section-search-select.vue';
import SectionTable from '@/components/common/retail-common/section-table.vue';
import YourBetslip from "../ticket/betslip/YourBetslipRetail";
import ModalCommon from '@/components/common/modal/modal-common.vue';
import GameService from "@/services/game.service";
import MarketService from "../../services/market.service";
import BallToggle from '@/components/common/ball/ball-toggle.vue';
import BallChosenUnderOver from '@/components/common/ball/ball-chosen-under-over.vue';
import BallNumbers from '@/components/common/ball/ball-numbers-retail.vue';
import YourBetslipMixinRetail from "../../mixins/betslip/your-betslip-retail-mixin";
import store from "../../store";
// const CURRENCY_CODE = process.env.VUE_APP_CURRENCY_CODE;

export default {
  mixins: [YourBetslipMixinRetail],
  components: {
    SectionSearchSelect,
    SectionTable,
    YourBetslip,
    ModalCommon,
    BallToggle
  },
  data() {
    return {
      currency: this.$store.state.currencyCode,
      betPerLine: 0,
      totalBets: 0,
      numbersBonusBall: [],
      BallNumbers,
      dataUnderOver: BallChosenUnderOver,
      numberDrawDropdown: 1,
      numberDropdown: 0,
      isFocusSearch: false,
      resultsNumberMain: [],
      resultsNumberAdditional: [],
      numberListMain: 90,
      listTitleLotteriesAdditional: ['Select', 'Lottery', 'Next Draw'],
      listMarkets: [
        [{ id: 1, isCheck: true, title: '(x) Odd'}, { id: 2, isCheck: false, title: '() Even'}],
        [{ id: 3, isCheck: false, title: '(x) High'}, { id: 4, isCheck: false, title: '() Low'}]
      ],
      numberListMaiBonus: 20,
      filterDate: '',
      listGames: [],
      listGamesToShow: [],
      mainMarkets: [],
      moreMarkets: [],
      moreMarketsToShow: [],
      numbersMainMarkets: [832, 833, 834, 1000, 1001, 1002, 1017, 1016],
      listChosen: [],
      listDataBetslip: [],
      drawsData: [],
      marketIndicators: [],
      isSelectMarket: false,
      itemsActive: []
    }
  },
  created() {
    const parameters = this.$route.query
    if (parameters) {
      this.$store.dispatch('initDataCustomer', parameters)
    }
  },
  beforeMount() {
    this.getInitialLoad('additional');
  },
  watch: {
    settings(val) {
      if (val) {
        this.accountSettings = val;
        if(Number(val.bet_default) > 0) {
          this.betPerLine = Number(val.bet_default);
        }
        if(Number(val.bet_min) > 0 && this.betPerLine < Number(val.bet_min)) {
          this.betPerLine = Number(val.bet_min);
        }
      } else {
        if(this.betPerLine < 0) {
          this.betPerLine = 0;
        }
      }
    },
    moreMarketsToShow: {
      handler(val){
        val.map(item => {
          for (const [_, m] of Object.entries(item.markets)) {
              for (const [_, v] of Object.entries(m.outcomes)) {
                if(v.isActive === true) {
                  this.isSelectMarket = true;
                }
              }
          }
        })
      },
      deep: true
    }
  },
  methods: {
    handleChosenNumberBonusBall(index, data) {
      this.numbersBonusBall.forEach(item => {
        if (index.key === item.key) {
          this.itemsActive = item.numbers.filter(item => item.isActive === true);
          item.numbers.forEach((number, _) => {
            number.isActive = number.number === index.number;
          })
        }
      })
      // this.$emit('handleChosenItem', {index, type: 'bonus', outcome: data})
    },
    handleClickItem(market, value) {
      let maxStake = 0;
      if(parseInt(value.data.max_payout) > 0) {
        maxStake = parseInt(value.data.max_payout) / value.value.odds
      } else {
        if(this.accountSettings.payout_max) {
          maxStake = parseInt(this.accountSettings.payout_max) / value.value.odds;
        }
      }
      let isAdd = true;
      let isReplace = false;
      this.listChosen.forEach(item => {
        if (item.key === value.data.key) {
          isAdd = false;
          isReplace = true;
        }
      })
      if (isAdd) {
        let outcome = '';
        for (const [k, v] of Object.entries(value.data.outcomes)) {
          if(value.value.text === v.text) {
            outcome = k
          }
        }
        const defaultChosen = {
          slug: this.marketSelectedAdditional.gameSlug,
          paid:  this.$filters.formatNumber(Number(this.accountSettings.bet_default)) || "",
          stake: this.$filters.formatNumber(this.betPerLine),
          stakeTaxAmount: "0.0000000000", //todo
          draws: 1, //todo
          market: market,
          drawDate: this.marketSelectedAdditional.drawDate,
          outcome: outcome,
          numbers: [],
          summary: value.data.summary,
          text: value.value.text,
          numOfBets: "1", //todo
          startDrawId: null, //todo
          betType: "Single", //todo
          systemBets: [], //todo
          isFreeBet: false, //todo
          wheelingId: "", //todo
          maxPayout: null, //todo
          drawName: `${this.marketSelectedAdditional.name} ${this.marketSelectedAdditional.drawDate}`,
          maxStake: maxStake,
          odds: Number(value.value.odds),
          toWin: parseInt(this.accountSettings.bet_default || 1) * Number(value.value.odds),
          moreDrawName: '',
        }
        if(this.listChosen[this.listChosen.length - 1]?.shortText && !this.listChosen[this.listChosen.length - 1]?.shortText) {
          this.listChosen[this.listChosen.length - 1] =
              {
                ...defaultChosen,
                shortText: value.value.text,
                key: value.data.key,
                moreDrawName: value.data.summary
              };
        } else {
          this.listChosen = [...this.listChosen, defaultChosen]
          this.listChosen[this.listChosen.length - 1] =
              {
                ...this.listChosen[this.listChosen.length - 1],
                shortText: value.value.text,
                key: value.data.key,
                moreDrawName: value.data.summary
              };
        }
      }
      if (isReplace) {
        this.listChosen.forEach(item => {
          if (item.key === value.data.key) {
            item.shortText = value.value.text;
          }
        })
      }
      this.moreMarketsToShow.map(item => {
        for (const [key, m] of Object.entries(item.markets)) {
          if(key === market) {
            for (const [k, v] of Object.entries(m.outcomes)) {
              v.isActive = v.text === value.value.text && v.isActive === false;
            }
          }
        }
      })
    },
    handleChangeRadioCheckboxLotteries(data) {
      this.marketSelectedAdditional = data.data;
      if(data.data.gameSlug) {
        this.handleGetMarkets(data.data.gameSlug);
      }
    },
    handleGetMarkets(slug) {
      this.moreMarketsToShow = [];
      if(slug) {
        MarketService.apiGetMarkets(slug).then(res => {
          if(res.draws) {
            this.drawsData = res.draws;
            this.numberDropdown = res.draws.length;
          }
          if(res.markets) {
            this.handleMainMoreMarkets(res)
          }
        })
      }
    },
    handleMainMoreMarkets(val) {
      let listItems = []
      let mainMarkets = [];
      let moreMarkets = [];
      for (const [_, item] of Object.entries(val.markets)) {
        listItems = [...listItems, item.markets]
        for (const [key, value] of Object.entries(item.markets)) {
          if(this.numbersMainMarkets.includes(parseInt(key))) {
            if(Number(key) === this.marketMaxPick) {
              this.maxPick = Object.keys(value.outcomes).length;
            }
            const valueMainMarket = { ...value, key }
            mainMarkets.push(valueMainMarket)
          }
        }
        let value = { ...item, isActive: true}
        moreMarkets = [...moreMarkets, value]
      }
      moreMarkets = moreMarkets.filter(markets => {
        for (const [key, _] of Object.entries(markets.markets)) {
          return !this.numbersMainMarkets.includes(parseInt(key))
        }
      })
      // moreMarkets = moreMarkets.filter(item=> Object.keys(item.markets).length >= 1)
      let keyNumber = 1;
      moreMarkets.map(item => {
        for (const [key, value] of Object.entries(item.markets)) {
          if(value.select_numbers === 'yes') {
            let numbers = {};
            if(val.game.ballset.rules[1] !== undefined) {
              numbers = this.initNumbers(val.game.ballset.rules[1].balls_min, val.game.ballset.rules[1].balls_max, 'bonus', key)
            } else {
              numbers = this.initNumbers(val.game.ballset.rules[0].balls_min, val.game.ballset.rules[0].balls_max, 'bonus', key)
            }
            value.keyNumbers = key;
            this.numbersBonusBall.push({key, numbers, value})
          }
          keyNumber++;
          value.key = keyNumber;
          for (const [k, v] of Object.entries(value.outcomes)) {
            v.name = item.name;
            v.isActive = false;
            const valueText = v.specifier;
            if(valueText !== '') {
              v.text = v.text.replace('{value}', valueText)
              v.short_text = v.short_text.replace('{value}', valueText)
              value.description = value.description.replace('{value}', valueText)
            }
          }
          value.isActiveToggle = true;
        }
      })

      this.mainMarkets = mainMarkets;
      this.moreMarkets = moreMarkets;
      this.moreMarketsToShow = moreMarkets;
    },
    initNumbers(ballsMin, ballsMax, type, key) {
      return Array(ballsMax).fill(ballsMax).map((_, index) => {
        const number = index + ballsMin;
        return { number, isActive: false, type, key }
      })
    },
    handleTabNextSectionMarket() {
      this.$refs.dropdown.focus();
    },
    nextSectionDropdown() {
      setTimeout(() => {
        this.$refs.dropdown.click();
        this.$refs.refBetPerLine.focus();
      }, 10)
    },
    handleSelectDrawDropdown(number) {
      this.numberDrawDropdown = number;
      this.$refs.dropdown.click();
      this.$refs.refBetPerLine.focus();
    },
    handleNextSectionMarket() {
      this.isFocusSearch = !this.isFocusSearch;
    },
    handleAddToBetslip() {
      for (const [_, value] of Object.entries(this.moreMarketsToShow)) {
        for (const [key, market] of Object.entries(value.markets)) {
          for (const [keyOutcome, outcome] of Object.entries(market.outcomes)) {
            this.marketIndicators = {
              ...this.marketIndicators,
              [key]: {
                ...this.marketIndicators[key],
                [keyOutcome]: outcome.isActive
              }
            }
          }
        }
      }
      // for (let i = 0; i < this.numberDrawDropdown; i++) {
      // }
      this.listBetslipsRetail.push(
          {
            selections: this.marketIndicators,
            games: [this.marketSelectedAdditional.gameSlug],
            stake: this.$filters.formatNumber(Number(this.betPerLine)),
            draws: this.numberDrawDropdown,
            numbers: [[],[]],
          }
      );
      this.showModalBetslip = true;
      this.getInitialLoad('additional');
      this.$store.dispatch('addDataToCartRetail', this.listBetslipsRetail);
      localStorage.setItem('listBetslipsRetail', JSON.stringify(this.listBetslipsRetail))
      this.handleProcessBetRetail(this.$store.getters.getCartRetail);
    },
    handleSelectMarket(data) {
      this.listMarkets.forEach(item => {
        if(item.some((element) => element.isCheck === true) === true) {
          item.forEach(market=> {
            if(market.id === data.id) {
              market.isCheck=!market.isCheck;
            } else {
             if(market.isCheck === true && item.some((element) => element.id === data.id)) {
               market.isCheck = false;
             }
            }
          })
        } else {
          item.forEach(market=> {
            if(market.id === data.id) {
              market.isCheck=!market.isCheck;
            }
          })
        }
      })
    },
    handleSelectItem(number, type) {
      if(type === 'main') {
        if(this.resultsNumberMain.includes(number)) {
          this.resultsNumberMain = this.resultsNumberMain.filter(item => item !== number);
        } else {
          this.resultsNumberMain.push(number);
        }
      } else {
        if(this.resultsNumberAdditional.includes(number)) {
          this.resultsNumberAdditional = this.resultsNumberAdditional.filter(item => item !== number);
        } else {
          this.resultsNumberAdditional.push(number);
        }
      }
    },
    trimString(s) {
      let l=0, r=s.length -1;
      while(l < s.length && s[l] === ' ') l++;
      while(r > l && s[r] === ' ') r-=1;
      return s.substring(l, r+1);
    },
    handleSearch(searchKey) {
      const dataSearch = this.trimString(searchKey);
      if(dataSearch !== '') {
        const arrGames = this.listGames.filter(obj => Object.values(obj).some(val => {
          if(typeof val === 'string') {
            return val.toLowerCase().includes(dataSearch.toLowerCase())
          }}));
        this.listGamesToShow = arrGames;
      } else {
        this.listGamesToShow = this.listGames;
      }
    },
    handleSearchMarkets(searchKey) {
      const dataSearch = this.trimString(searchKey);
      if(dataSearch !== '') {
        this.moreMarketsToShow = this.moreMarkets.filter(obj => Object.values(obj).some(val => {
          if (typeof val === 'string') {
            return val.toLowerCase().includes(dataSearch.toLowerCase())
          }
        }));
      } else {
        this.moreMarketsToShow = this.moreMarkets;
      }
    },
  }
}
</script>

<style scoped lang="scss" src="@/assets/scss/retail/tab-main-markets.scss"/>
<style scoped lang="scss" src="@/assets/scss/retail/additional-market.scss"/>
